import { RESET_EMAIL } from 'redux/modules/forgot-password/actions/types';

export const resetEmail = () => dispatch =>
  dispatch({
    type: RESET_EMAIL,
  });
